<template>
  <div v-if="visible" class="location-map-modal-overlay" @click="closeModal">
    <div class="location-map-modal" @click.stop>
      <div class="modal-header">
        <h3>Select Location</h3>
        <button class="close-button" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="modal-body">
        <LocationMapSelector 
          :initial-location="initialLocation"
          @location-selected="onLocationSelected"
          @close="closeModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LocationMapSelector from './LocationMapSelector.vue'

export default {
  name: 'LocationMapModal',
  components: {
    LocationMapSelector
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialLocation: {
      type: Object,
      default: null
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    
    onLocationSelected(location) {
      this.$emit('location-selected', location);
      this.closeModal();
    }
  }
}
</script>

<style scoped>
.location-map-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.location-map-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.modal-header h3 {
  margin: 0;
  color: #212529;
  font-size: 20px;
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  color: #6c757d;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: #e9ecef;
  color: #495057;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .location-map-modal-overlay {
    padding: 10px;
  }
  
  .location-map-modal {
    max-height: 95vh;
  }
  
  .modal-header {
    padding: 16px 20px;
  }
  
  .modal-body {
    padding: 16px;
  }
  
  .modal-header h3 {
    font-size: 18px;
  }
}
</style>
